import(/* webpackMode: "eager" */ "/app/src/app/auth/signin/page.tsx");
